import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';
import { shouldForwardProp } from '@/utils/style.utils';
import { css } from '@emotion/react';

const FlightCardWrapper = styled.div`
  position: relative;
  flex: 1;
`;

const SearchCard = styled('div', { shouldForwardProp })<{ $isInGroup?: boolean }>`
  display: flex;
  max-width: 894px;
  border-bottom: ${({ $isInGroup }) => ($isInGroup ? `solid 1px ${color(COLOR_VARIANTS.GAINSBORO)}` : `0`)};
`;

const FareFamilies = styled('div', { shouldForwardProp })<{ $isInGroup?: boolean }>`
  border-bottom: ${({ $isInGroup }) => ($isInGroup ? `solid 1px ${color(COLOR_VARIANTS.GAINSBORO)}` : `0`)};
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 892px;
  padding: 16px 16px 16px 16px;
  border-top: 0;
  overflow-x: hidden;
`;

const Messages = styled.div`
  position: absolute;
  bottom: 16px;
  display: flex;
  align-items: end;
  gap: 8px;
  flex-wrap: wrap;
`;

const SearchCardContent = styled('div', { shouldForwardProp })<{
  $isRoundTrip?: boolean;
  $hasSortedTags: boolean;
  $hasWarning: boolean;
  $isMultiCity: boolean;
}>`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: ${({ $isRoundTrip }) => ($isRoundTrip ? 'space-between' : 'center')};

  padding-top: ${({ $isRoundTrip, $hasSortedTags, $hasWarning, $isMultiCity }) => {
    if ($isRoundTrip || $isMultiCity) {
      if ($hasSortedTags) {
        return '56px';
      }
      if ($hasWarning && !$hasSortedTags) {
        return '16px';
      }
    }
    return '16px';
  }};

  padding-bottom: ${({ $isRoundTrip, $hasSortedTags, $hasWarning }) => {
    if ($isRoundTrip) {
      if ($hasWarning) {
        return '56px';
      }
      if (!$hasSortedTags && !$hasWarning) {
        return '16px';
      }
    }
    return '16px';
  }};
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;

const LegWrapper = styled('div', { shouldForwardProp })<{
  $haveMixedCabin?: boolean;
  $hasSortedTags?: boolean;
  $isRoundTrip: boolean;
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;

  ${({ $haveMixedCabin }) =>
    $haveMixedCabin &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
    `}
`;

const SortedTags = styled('div', { shouldForwardProp })<{ $isRoundTrip?: boolean }>`
  position: absolute;
  top: 16px;
  margin-bottom: ${({ $isRoundTrip }) => ($isRoundTrip ? '16px' : '24px')};
`;

export default {
  FlightCardWrapper,
  SearchCard,
  FareFamilies,
  Messages,
  SearchCardContent,
  Card,
  LegWrapper,
  SortedTags,
};
